{
  "$schema": "http://json-schema.org/draft-07/schema",
  "$id": "LocationDefinition",
  "definitions": {
    "LocationSchema": {
      "description": "A generic location entity which can be used for physical, digital or placeholder places. For example: a house, building, room, Zoom URL",
      "type": "object",
      "required": [
        "id",
        "created_by",
        "created_at",
        "deleted_by",
        "deleted_at",
        "profile_id",
        "name",
        "address1",
        "address2",
        "city",
        "postcode",
        "url"
      ],
      "additionalProperties": false,
      "properties": {
        "id": {
          "type": "string",
          "format": "uuid"
        },
        "created_by": {
          "type": "string"
        },
        "created_at": {
          "type": "string",
          "format": "date-time"
        },
        "deleted_by": {
          "type": ["string", "null"],
          "format": "uuid"
        },
        "deleted_at": {
          "type": ["string", "null"],
          "format": "date-time"
        },
        "profile_id": {
          "type": "string"
        },
        "name": {
          "type": "string"
        },
        "address1": {
          "type": ["string", "null"]
        },
        "address2": {
          "type": ["string", "null"]
        },
        "city": {
          "type": ["string", "null"]
        },
        "postcode": {
          "type": ["string", "null"]
        },
        "url": {
          "type": ["string", "null"]
        }
      }
    }
  }
}
